jQuery( function( $ ) {
	$( '#pills-tab a:first' ).click();
} );
